import { DataProvider } from '@plasmicapp/host';
import { useABTestStore } from 'hooks/stores/useABTestStore';
import { usePrizeStore } from 'hooks/stores/usePrizeStore';
import { useUTMStore } from 'hooks/stores/useUTMStore';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

// Users will be able to set these props in Studio.
interface PrizeGlobalContextProps {
  // You might use this to override the auth URL to a test or local URL.
}

export const PrizeGlobalContext = observer(
  ({ children }: React.PropsWithChildren<PrizeGlobalContextProps>) => {
    const {
      dashboardPrizes,
      dashboardPrizeSelected,
      selectedLandingPagePrize,
      setLandingPagePrizeFromUTMContent,
    } = usePrizeStore();
    const { utmParams } = useUTMStore();
    const { abTests } = useABTestStore();

    useEffect(() => {
      (async () => {
        if (utmParams.utm_content) {
          setLandingPagePrizeFromUTMContent(utmParams.utm_content);
        }
      })();
    }, []);

    return (
      <DataProvider
        name="prizes"
        data={{
          trendingPrizes: dashboardPrizes,
          trendingPrizeSelected: dashboardPrizeSelected,
          selectedLandingPagePrize,
          abTests,
        }}
      >
        {children}
      </DataProvider>
    );
  }
);
